import {
  GET_WORKOUT_SUCCEED,
  GET_WORKOUT_ERROR,
  LOADING_STATE,
  CREATE_WORKOUT_LOG_SUCCEED,
  CREATE_WORKOUT_LOG_ERROR,
  GET_WORKOUT_LAST_LOG_SUCCESS,
  GET_WORKOUT_LAST_LOG_ERROR,
  GET_WORKOUT_LOG_SUCCESS,
  GET_WORKOUT_LOG_ERROR,
  LOADING_LAST_LOGGED_WORKOUT
} from './types';

const INITIAL_STATE = {
  workout: {},
  workoutLog: {},
  loading: false,
  logIsSubmitted: false,
  lastLoggedWorkout: {},
  currentWorkoutLog: {},
  loadingLastLogedWorkout: false
};

export default function(state = INITIAL_STATE, action) {
  if (action.type === GET_WORKOUT_SUCCEED) {
    return { ...state, workout: action.payload, loading: false, logIsSubmitted: false };
  } else if (action.type === GET_WORKOUT_ERROR) {
    return { ...state, error: action.payload, loading: false, logIsSubmitted: false };
  } else if (action.type === LOADING_STATE){
    return { ...state, loading: true, logIsSubmitted: false };
  } else if (action.type === CREATE_WORKOUT_LOG_SUCCEED) {
    return { ...state, loading: false, logIsSubmitted: true };
  } else if (action.type === CREATE_WORKOUT_LOG_ERROR) {
    return { ...state, loading: false, logIsSubmitted: false };
  } else if (action.type === GET_WORKOUT_LAST_LOG_SUCCESS) {
    return { ...state, lastLoggedWorkout: action.payload, loadingLastLogedWorkout: false };
  } else if (action.type === GET_WORKOUT_LAST_LOG_ERROR) {
    return { ...state, error: action.payload, loadingLastLogedWorkout:false };
  } else if (action.type ===  GET_WORKOUT_LOG_SUCCESS) {
    return { ...state, currentWorkoutLog: action.payload, loading: false };
  } else if (action.type ===  GET_WORKOUT_LOG_ERROR) {
    return { ...state, error: action.payload, loading: false };
  } else if (action.type ===  LOADING_LAST_LOGGED_WORKOUT) {
    return { ...state, loadingLastLogedWorkout: true };;
  } else {
    return state;
  }
}
